import React from 'react'


export default function KeyEvent(props) {
  const [pressedKeys, setPressedKeys] = React.useState([])

  React.useEffect(() => {
    const onKeyDown = ({ key }) => {
      if (
        props.allowedKeys.includes(key.toUpperCase()) &&
        ! pressedKeys.includes(key.toUpperCase())
      ) {
        setPressedKeys(previousPressedKeys => [...previousPressedKeys, key])
        props.onKeyDown()
      }
    }

    const onKeyUp = ({ key }) => {
      if (props.allowedKeys.includes(key.toUpperCase())) {
        setPressedKeys(previousPressedKeys => previousPressedKeys.filter(k => k !== key.toUpperCase()))
        props.onKeyUp()
      }
    }

    document.addEventListener('keydown', onKeyDown)
    document.addEventListener('keyup', onKeyUp)

    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.removeEventListener('keyup', onKeyUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <>{props.children}</>
}
